// extracted by mini-css-extract-plugin
export var footerContainer = "footer-module--footerContainer--j8hKz";
export var footerIcon = "footer-module--footerIcon--iwyjz";
export var footerIcons = "footer-module--footerIcons--cryHK";
export var footerText = "footer-module--footerText--mHgNW";